import './App.css';
import React, { useEffect, useState } from 'react';
import { Strava } from 'strava';

function App() {
  // const strava = new Strava({
  //   client_id: process.env.REACT_APP_CLIENT_ID,
  //   client_secret: process.env.REACT_APP_CLIENT_SECRET,
  //   refresh_token: process.env.REACT_APP_REFRESH_TOKEN,
  // });

  // const [ activities, setActivities ] = useState([]);

  // useEffect(() => {
  //   async function getActivities() {
  //     try {
  //       const ret_activities = await strava.activities.getLoggedInAthleteActivities({per_page: 200});
  //       console.log(ret_activities);
  //       setActivities(ret_activities);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }
  //   getActivities();
  // }, []);

  return (
    <div className="App">
      <header className="App-header">
        <p>A work in progress ... for now, just a list of ideas I would like to see on a digital representation of myself.</p>
      </header>
      <img src="https://hitwebcounter.com/counter/counter.php?page=17631048&style=0007&nbdigits=5&type=page&initCount=0" title="Counter Widget" Alt="Visit counter For Websites"   border="0" />
      <dl>
        <dt>Sport</dt>
        <iframe height='160' width='300' frameborder='0' allowtransparency='true' scrolling='no' src='https://www.strava.com/athletes/96339213/activity-summary/28ee508e20e35a9c5b42554ca9824c327a8e4850'></iframe>
        {/* <dd>- hook it up to the strava API, maybe on a cron job</dd> */}
        {/* <dd>- (using the strava api) here's how many activities ive done: coming soon on prod<span style={{color: "red"}}>{activities.length}</span></dd> */}
        <dd>- I used to race for the Yale Triathlon team, I now race with the Golden Gate Triathlon Club in SF</dd>
        <dd>- upcoming races / tris</dd>
          <ul>
            <li>Ironman 70.3 Santa Cruz - 9/13/26</li>
            <li>Ironman California - 10/18/26</li>
            <li>California International Marathon - 12/6/26</li>
          </ul>
        <dd>- finished races / tris</dd>
          <ul>
            <li>Year 1</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/11028515730/overview">Philly Love Run</a> (half marathon) - 3/24/24: finished in 2:04:28, goal: finish</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/athletes/96339213/posts/31110279">Ironman 70.3 Ohio</a> - 7/21/24: finished in 6:16:09, goal: finish</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/12307138698/overview">Faxon Law New Haven Road Race</a> (half marathon) - 9/2/24: finished in 1:46:35, goal: &lt;1:50</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/athletes/96339213/posts/32293625">Toughman Northeast Collegiate Triathlon</a> (Olympic Distance) - 9/14/24: finished in 3:10:56, goal: &lt;3:00</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/12532346885/overview">Treasure Island Triathlon / Duathlon</a> (Sprint) - 9/29/24: finished in 1:02:23, goal: none specific, qualified for USA Triathlon Sprint/Olympic Nationals</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/12975849026/overview">Philadelphia Marathon</a> - 11/24/24: finished in 4:11:03, goal: &lt;3:50</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.athlinks.com/event/21233/results/Event/1103199/Course/2567906/Bib/1675">IRIS 5k</a> - 2/9/25: finished in 22:18, goal: &lt;22:00</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/14021028774/overview">USA Triathlon Collegiate Club National Championships</a> (Olympic Distance) - 3/29/25: finished in 2:51:55, goal: &lt;3:00</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/14223494771/overview">Newport Half Marathon</a> - 4/19/25: finished in 1:41:06, goal: &lt;1:40 (disclaimer: sick)</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/14306896889/overview">Jack Bristol Lake Waramaug Ultramarathon (50 mi)</a> - 4/27/25: finished in 10:45:06, goal: finish</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/athletes/96339213/posts/40169081">Ironman Lake Placid</a> - 7/20/25: finished in 14:12:49, goal: finish</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/16680164022/overview">Ironman 70.3 La Quinta</a> - 12/7/25: finished in 5:31:25, goal: &lt;5:30, awa bronze</li>
            <li>Year 2</li>
            <li>Stanford Treeathlon (sprint) - 2/14/26: mental DNF</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/18071287824/overview">Napa Valley spring Tri</a> (olympic distance) - 4/11/26: finished in 2:53:54</li>
            <li><a rel="noreferrer" target="_blank" href="https://www.strava.com/activities/18364806950/overview">Wildflower</a> (olympic distance) - 5/3/26: finished in 3:02:59</li>
            <li>Escape from Alcatraz Tri - 6/7/26: finished in 3:05:20</li>
          </ul>
        <dd>- races/routes on the bucket list</dd>
          <ul>
            <li>Pittsburgh dirty dozen (cycling)</li>
            <li>crit / cat (cycling)</li>
            <li>velodrome track (cycling)</li>
            <li>swim across america (OWS)</li>
            <li>biathlon</li>
            <li>trans tahoe relay / tahoe marathon swim</li>
          </ul>
        <dd>- trying to get better at </dd>
          <ul>
            <li>Surfing (mavericks, winter OB)</li>
            <li>Snowboarding and skiing</li>
            <li>skateboarding/longboarding, e.g. a josh neumann-esque bomb on the longboard</li>
            <li>outdoor climbing</li>
            <li>swimming and rowing and sailing</li>
          </ul>
        <dd>- other sports</dd>
          <ul>
            <li>baseball, pitched and played 2nd for college club ball and high school. can switch hit and somewhat switch throw. </li>
            <li>pole vault, one high school season</li>
            <li>cornhole. second best cornhole player in college.</li>
            <li>soccer, IM goalkeeper</li>
          </ul>
        <dd>- bikes</dd>
          <ul>
            <li>[retired] 2010-2014 Cervelo P2 Rim MK1 "Kellie"</li>
            <li>2010 Trek Alpha 2.3 "Alpha"</li>
            <li>Quintana Roo X-PR "Roo"</li>
            <li>looking for a fixie, a track bike, and a racing road bike to round out the squad</li>
          </ul>
        <dt>Travel</dt>
        <dd>- national parks ranking (not set in stone, will adapt as I revisit places) done: 12/63</dd>
          <ol>
            <li>Olympic (Washington)</li>
            <li>Yosemite (California)</li>
            <li>Crater Lake (Oregon)</li>
            <li>Lassen Volcanic (California)</li>
            <li>Joshua Tree National Park (California)</li>
            <li>Pinnacles National Park (California)</li>
            <li>Grand Canyon (Arizona)</li>
            <li>Volcano National Park (Hawaii)</li>
            <li>New River Gorge (West Virginia)</li>
            <li>Indiana Dunes (Indiana)</li>
            <li>Shenandoah (Virginia)</li>
            <li>Cuyahoga Valley (Ohio)</li>
          </ol>
        {/* <dd>- countries (15)</dd>
          <ul>
            <li>[x] USA</li>
            <li>[x] Canada</li>
            <li>[x] Mexico</li>
            <li>[x] Dominican Republic</li>
            <li>[x] Ireland</li>
            <li>[x] China</li>
            <li>[x] Iceland</li>
            <li>[x] Germany</li>
            <li>[x] Czech Republic</li>
            <li>[x] France</li>
            <li>[x] Italy</li>
            <li>[x] Netherlands</li>
            <li>[x] Spain</li>
            <li>[x] Vatican City</li>
            <li>[x] Taiwan</li>
            <li>[x] Switzerland</li>
          </ul> */}
        <dt>Research + Pedagogy</dt>
        <dd>- to add some permanence to my ideas</dd>
        <dd>- things i would like to explore, see open problems in computational topology</dd>
        <dd>- arxiv api maybe</dd>
        <dd>- also taught for <a rel="noreferrer" target="_blank" href="https://yale.learningu.org/teach/teachers/jeffreyjgong/bio.html">Splash</a> on: New/Gonzo Journalism, Heat Equation, and General Relativity</dd>
        <dt>professional</dt>
        <dd>- I'm a part of the second cohort of APMs (Associate Product Managers) at Databricks, working on intelligent Lakehouse storage</dd>
        <dd>- I used to work as a software engineer for [Riot Games, Philadelphia Phillies, Boston Quantum, CarMax, EsurgiBiotech] where I worked on [Rust in-house source control, player development and modeling, API for quantum currency arbitrage, internal tooling, and embedded physical therapy software]</dd>
        <dd>- I'm always available to hear about interesting projects (<a href="mailto:jeffrey.gong7@gmail.com">email me</a>)</dd>
        <dd>- <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/jeffrey-gong7/">linkedin</a></dd>
        <dd>- schooling + other: I graduated from Yale in 2025 with a joint CS+Math degree, I graduated from Methacton High School as valedictorian in 2021.</dd>
        <dt>Film</dt>
        <dd>- my <a rel="noreferrer" target="_blank" href="https://letterboxd.com/auteurphile/">letterboxd</a></dd>
        <dt>Books</dt>
        <dd>- a virtual library of words that meant something to me</dd>
        <dd>- my <a rel="noreferrer" target="_blank" href="https://www.goodreads.com/user/show/181244410-jeffrey-gong">goodreads</a></dd>
        <dt>Typing</dt>
        <dd>- monkeytype <a rel="noreferrer" target="_blank" href="https://monkeytype.com/profile/jeffreyjgong">profile</a> - wpm pr: 181</dd>
        <dt>Chess</dt>
        <dd>- chess.com <a rel="noreferrer" target="_blank" href="https://www.chess.com/member/greatkingjeff">profile</a></dd>
      </dl>
    </div>
  );
}

export default App;
